export default "__VITE_ASSET__DFpK_USe__"